import React, { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import { getSingleForm, updateForm, listForms } from "./../../../config/forms_api_calls";
import {
  getIntegration,
  getServicesUpdate,
  getOutboundSBCIntegration,
} from "./../../../config/reseller_api_calls";
import { getSuppliesBusinessTypes } from "./../../../config/general_api_calls";
import $ from "jquery";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import HelperClass from "./../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import dateFormat, { masks } from "dateformat";
import FormBuilderClass from "../../../components/Reseller/FormBuilderClass";
import Tooltip from "@material-ui/core/Tooltip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "react-select";
import localization from "../../../localization/enUS";

const auth = new HelperClass();

class EditForm extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: "",
      successMessage: "",
      tableLoader: true,
      disabled: false,
      form_title: "",
      form_desc: "",
      form_content: [],
      showOnDashboard: false,
      form_sequence: "1",
      form_sequence_error: "",
      btn_text: "",
      allow_multiple: false,
      is_default: false,
      attach_to: false,
      allow_submit: true,
      link_form: false,
      external_link: "",
      groups: {},
      isEditorReady: false,
      copiedBadge: "",
      showTooltip: false,
      va_intergation: "No",
      agent_default: false,
      supplier_default: false,
      ai_agent_creation: false,
      selectedAttachProfile: "",
      for_bcid: false,
      bcid_allowed: false,
      api_status: false,
      order_form: false,
      selectAllClient: false,
      selectedClients: [],
      selectedOrderForm: [],
      lead_generation_form: false,
      lead_generation_external_link: "",
      ai_agent_creation_external_link: "",

      notification_scheduler: false,
      schedule_div: false,
      repeat_count: 7,
      repeat_interval: 24,
      initial_reminder_interval: 2,
      notification_loader: false,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      account_creation: false,

      required_business_type: false,
      business_type: "",
      supplier_business_types: [],
      captcha_enabled: false,
      is_sipnav: false,
      existingForms: [],
      formsListLoaded: false,
      outboundSBCEnabled: false,
    };
  }

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  handleSelectChange = (selectedOptions) => {
    this.setState({ selectedClients: selectedOptions }, () => {
      const { clientsList, selectedClients } = this.state;

      const selectAll = clientsList.length === selectedClients.length;
      this.setState({ selectAllClient: selectAll });

      // console.log("Selected Services:", selectedClients);
    });
  };

  handleSelectAllChange = () => {
    this.setState((prevState) => {
      const selectAll = !prevState.selectAllClient;
      return {
        selectAllClient: selectAll,
        selectedClients: selectAll ? prevState.clientsList : [],
      };
    });

    // console.log(
    //   "Select All Changed:",
    //   !this.state.selectAllClient ? "All selected" : "None selected"
    // );
  };

  async componentDidMount() {
    let form_accountno = this.props.props.match.params.id;
    this.setState({
      errorMessage: "",
      successMessage: "",
      form_accountno: form_accountno,
    });
    const servicesResponce = await getSingleForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );
    // console.log("servicesResponce: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let form_sequence =
        servicesResponce.data.data[0]["form_sequence"] &&
        servicesResponce.data.data[0]["form_sequence"] > 0
          ? servicesResponce.data.data[0]["form_sequence"]
          : "1";
      let btn_text =
        servicesResponce.data.data[0]["btn_text"] &&
        servicesResponce.data.data[0]["btn_text"] !== ""
          ? servicesResponce.data.data[0]["btn_text"]
          : "";

      let notification_scheduler = false;
      let schedule_div = false;
      let repeat_count = "";
      let repeat_interval = "";
      let initial_reminder_interval = "";
      if (
        servicesResponce.data.escalationSettings &&
        servicesResponce.data.escalationSettings.length > 0
      ) {
        let escalationSettings = servicesResponce.data.escalationSettings;
        notification_scheduler =
          escalationSettings[0]["is_active"] &&
          escalationSettings[0]["is_active"] === 1
            ? true
            : false;
        schedule_div =
          escalationSettings[0]["is_active"] &&
          escalationSettings[0]["is_active"] === 1
            ? true
            : false;
        repeat_count = escalationSettings[0]["repeat_count"];
        repeat_interval = escalationSettings[0]["repeat_interval"];
        initial_reminder_interval =
          escalationSettings[0]["initial_reminder_interval"];
      }

      this.setState(
        {
          form_title: servicesResponce.data.data[0]["form_title"],
          form_desc: servicesResponce.data.data[0]["form_desc"],
          form_content: JSON.parse(
            servicesResponce.data.data[0]["form_content"],
          ),
          groups: JSON.parse(servicesResponce.data.data[0]["groups"]),
          showOnDashboard: servicesResponce.data.data[0]["show_on_dashboard"],
          allow_multiple: servicesResponce.data.data[0]["allow_multiple"],
          is_default: servicesResponce.data.data[0]["is_default"],
          agent_default: servicesResponce.data.data[0]["agent_default"],
          supplier_default: servicesResponce.data.data[0]["supplier_default"],
          ai_agent_creation:
            servicesResponce.data.data[0]["ai_agent_creation"] === 0
              ? false
              : true,
          attach_to: servicesResponce.data.data[0]["attach_to"],
          allow_submit: servicesResponce.data.data[0]["allow_submit"],
          link_form:
            servicesResponce.data.data[0]["link_form"] === 0 ? false : true,
          lead_generation_form:
            servicesResponce.data.data[0]["lead_generation_form"] === 0
              ? false
              : true,
          captcha_enabled:
            servicesResponce.data.data[0]["captcha_enabled"] === 1 ||
            servicesResponce.data.data[0]["captcha_enabled"] === "1"
              ? true
              : false,
          is_sipnav:
            servicesResponce.data.data[0]["is_sipnav"] === 1 ||
            servicesResponce.data.data[0]["is_sipnav"] === "1"
              ? true
              : false,
          for_bcid:
            servicesResponce.data.data[0]["for_bcid"] === 0 ? false : true,
          account_creation:
            servicesResponce.data.data[0]["account_creation"] === 0
              ? false
              : true,
          external_link: servicesResponce.data.data[0]["external_link"],
          lead_generation_external_link:
            servicesResponce.data.data[0]["lead_generation_external_link"],
          ai_agent_creation_external_link:
            servicesResponce.data.data[0]["ai_agent_creation_external_link"],
          selectedAttachProfile:
            servicesResponce.data.data[0]["selectedAttachProfile"],
          order_form: servicesResponce.data.data[0]["order_form"],
          required_business_type:
            servicesResponce.data.data[0]["required_business_type"],
          business_type: servicesResponce.data.data[0]["business_type"],
          selectedOrderForm: servicesResponce.data.data[0]["selectedOrderForm"]
            ? JSON.parse(servicesResponce.data.data[0]["selectedOrderForm"])
            : [],
          form_sequence: form_sequence,
          btn_text: btn_text,
          notification_scheduler: notification_scheduler,
          schedule_div: schedule_div,
          repeat_count: repeat_count,
          repeat_interval: repeat_interval,
          initial_reminder_interval: initial_reminder_interval,
          tableLoader: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ isEditorReady: true });
          }, 500);
        },
      );
    } else {
      //window.location.replace("/error");
    }
    this.get_integration_data();
    this.get_services_data();
    this.getSuppliesBusinessTypes();
    this.fetchExistingForms();
    this.fetchOutboundSBCStatus();
  }

  fetchExistingForms = async () => {
    try {
      const response = await listForms(auth.getAccount(), auth.getToken());
      if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        this.setState({ existingForms: response.data.data || [], formsListLoaded: true });
      } else {
        this.setState({ formsListLoaded: true });
      }
    } catch (error) {
      console.log("Error fetching existing forms: ", error);
      this.setState({ formsListLoaded: true });
    }
  };

  fetchOutboundSBCStatus = async () => {
    try {
      const response = await getOutboundSBCIntegration(auth.getAccount(), auth.getToken());
      if (response.data.status === 200 && response.data.data) {
        this.setState({ outboundSBCEnabled: response.data.data.is_enabled === 1 });
      }
    } catch (error) {
      console.log("Error fetching Outbound SBC status: ", error);
    }
  };

  checkDuplicateTitle = (title, excludeFormAccountno) => {
    const { existingForms } = this.state;
    if (!title || !existingForms || existingForms.length === 0) {
      return false;
    }
    const normalizedTitle = title.trim().toLowerCase();
    return existingForms.some(
      (form) =>
        form.form_title &&
        form.form_title.trim().toLowerCase() === normalizedTitle &&
        form.form_accountno !== excludeFormAccountno
    );
  };

  get_services_data = async () => {
    let form_accountno = this.props.props.match.params.id;
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getServicesUpdate(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );
    // console.log("get_services_data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let assignServices = servicesResponce.data.services;
      let clients = servicesResponce.data.data.map((client) => ({
        value: client.id,
        label: client.service_title,
      }));
      let selectedClients = assignServices.map((service) => ({
        value: service.id,
        label: service.service_title,
      }));
      this.setState({
        clientsList: clients,
        selectedClients: selectedClients,
        selectAllClient: clients.length === selectedClients.length,
      });
    } else {
    }
  };

  get_integration_data = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getIntegration(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_integration_data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let va_intergation = "No";
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          // console.log(
          //   'servicesResponce.data.data[i]["integration_type"]' +
          //     servicesResponce.data.data[i]["active"] +
          //     " " +
          //     servicesResponce.data.data[i]["integration_type"] +
          //     " " +
          //     servicesResponce.data.data[i]["status"]
          // );
          if (
            servicesResponce.data.data[i]["integration_type"] ===
              "voicealerts" &&
            servicesResponce.data.data[i]["active"] === 1 &&
            servicesResponce.data.data[i]["status"] === "Yes"
          ) {
            va_intergation = "Yes";
          }
        }
      }
      let bcid_allowed = false;
      let api_status = false;
      // console.log(
      //   "servicesResponce.data.apiSettings.bcid_allowed: ",
      //   servicesResponce.data.apiSettings[0]
      // );
      if (
        servicesResponce.data.apiSettings &&
        servicesResponce.data.apiSettings.length > 0
      ) {
        // console.log(
        //   "servicesResponce.data.apiSettings.bcid_allowed: ",
        //   servicesResponce.data.apiSettings[0]
        // );
        bcid_allowed =
          servicesResponce.data.apiSettings[0]["bcid_allowed"] === 0
            ? false
            : true;
        api_status =
          servicesResponce.data.apiSettings[0]["status"] === 0 ? false : true;
      }
      // console.log("va_intergation: ", va_intergation);
      this.setState({
        va_intergation: va_intergation,
        bcid_allowed: bcid_allowed,
        api_status: api_status,
      });
    } else {
    }
  };

  handleBadgeClick = (content) => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        this.setState({ copiedBadge: content, showTooltip: true });
        setTimeout(() => {
          this.setState({ copiedBadge: "", showTooltip: false });
        }, 700);
      })
      .catch((error) => {
        console.error("Unable to copy text to clipboard:", error);
      });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleGroupsChange = (groups) => {
    this.setState({ groups: groups });
  };

  handleCaptchaEnabledChange = (event) => {
    this.setState({
      captcha_enabled: event.target.checked,
    });
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  };

  handleFormContentChange = (formContent) => {
    this.setState({ form_content: formContent });
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ form_desc: updatedContent });
  };

  handleFormSubmit = () => {
    if (!this.state.formsListLoaded) {
      this.setState({ errorMessage: "Please wait, loading form data..." });
      setTimeout(() => this.setState({ errorMessage: "" }), 2500);
      return;
    }

    const {
      form_title,
      form_desc,
      form_content,
      form_sequence,
      btn_text,
      form_sequence_error,
      showOnDashboard,
      allow_multiple,
      is_default,
      attach_to,
      allow_submit,
      link_form,
      external_link,
      groups,
      agent_default,
      selectedAttachProfile,
      for_bcid,
      order_form,
      selectedClients,
      lead_generation_form,
      lead_generation_external_link,
      account_creation,
      notification_scheduler,
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      supplier_default,
      required_business_type,
      business_type,
      ai_agent_creation,
      ai_agent_creation_external_link,
      captcha_enabled,
      is_sipnav,
    } = this.state;
    let isValidated = true;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const isValidContent = form_content.every((form) => {
      const validQuestions = form.questions.filter(
        (question) =>
          question.questionText.trim() !== "" &&
          question.answerType.trim() !== "",
      );
      return validQuestions.length > 0;
    });

    // Check if dropdown questions have at least one option
    const hasInvalidDropdown = form_content.some((form) => {
      return form.questions.some((question) => {
        if (question.answerType === "dropdown" && question.questionText.trim() !== "") {
          return !question.options || question.options.filter(opt => opt.trim() !== "").length === 0;
        }
        return false;
      });
    });

    if (!form_title || !form_desc) {
      isValidated = false;
      this.setState({
        errorMessage: "Form title and description are required.",
      });
    } else if (hasInvalidDropdown) {
      isValidated = false;
      this.setState({
        errorMessage: "Options are required for dropdown questions. Please add at least one option.",
      });
    } else if (!link_form && (!isValidContent || form_content.length <= 0)) {
      isValidated = false;
      this.setState({
        errorMessage:
          "Form must have at least one valid question with both question text and answer type filled.",
      });
    } else if (form_sequence === "") {
      isValidated = false;
      this.setState({
        errorMessage: "Sequence number is required.",
      });
    } else if (form_sequence_error !== "") {
      isValidated = false;
      this.setState({
        errorMessage: "Please enter correct sequence number.",
      });
    } else if (showOnDashboard && !link_form) {
      if (!btn_text || btn_text === "") {
        isValidated = false;
        this.setState({
          errorMessage: "Button text must be provided.",
        });
      }
    } else if (attach_to && !selectedAttachProfile) {
      isValidated = false;
      this.setState({
        errorMessage: "Please select a profile to attach.",
      });
    } else if (link_form) {
      if (!external_link || external_link === "") {
        isValidated = false;
        this.setState({
          errorMessage: "Form link cannot be empty.",
        });
      }
    } else if (lead_generation_form) {
      if (
        !lead_generation_external_link ||
        lead_generation_external_link === ""
      ) {
        isValidated = false;
        this.setState({
          errorMessage: "Api Url cannot be empty.",
        });
      }
    } else if (ai_agent_creation) {
      if (
        !ai_agent_creation_external_link ||
        ai_agent_creation_external_link === ""
      ) {
        isValidated = false;
        this.setState({
          errorMessage: "Api Url cannot be empty.",
        });
      }
    } else if (order_form && selectedClients.length < 0) {
      isValidated = false;
      this.setState({
        errorMessage: "Please select a profile to attach.",
      });
    } else if (supplier_default && business_type === "") {
      isValidated = false;
      this.setState({
        errorMessage: "Please select a business type.",
      });
    }

    if (isValidated && this.checkDuplicateTitle(form_title, this.state.form_accountno)) {
      isValidated = false;
      this.setState({
        errorMessage: "A form with this title already exists. Please use a different title.",
      });
    }

    const filteredContent = form_content.map((form) => ({
      ...form,
      questions: form.questions
        .filter(
          (question) =>
            question.questionText.trim() !== "" &&
            question.answerType.trim() !== "",
        )
        .map((question) => ({
          ...question,
          options:
            (question.answerType === "checkbox" ||
              question.answerType === "radio") &&
            question.options
              ? question.options.filter((option) => option.trim() !== "")
              : question.options,
        })),
    }));

    setTimeout(() => {
      this.setState({ errorMessage: "" });
    }, 2500);

    const content = JSON.stringify(filteredContent);

    if (isValidated) {
      const groups_string = JSON.stringify(groups);
      this.saveForm(
        form_title,
        form_desc,
        content,
        form_sequence,
        btn_text,
        showOnDashboard,
        allow_multiple,
        is_default,
        groups_string,
        attach_to,
        allow_submit,
        link_form,
        external_link,
        agent_default,
        selectedAttachProfile,
        for_bcid,
        order_form,
        selectedClients,
        lead_generation_form,
        lead_generation_external_link,
        account_creation,
        notification_scheduler,
        repeat_count,
        repeat_interval,
        initial_reminder_interval,
        supplier_default,
        required_business_type,
        business_type,
        ai_agent_creation,
        ai_agent_creation_external_link,
        captcha_enabled,
        is_sipnav,
      );
    }
  };

  saveForm = async (
    title,
    desc,
    content,
    form_sequence,
    btn_text,
    showOnDashboard,
    allow_multiple,
    is_default,
    groups_string,
    attach_to,
    allow_submit,
    link_form,
    external_link,
    agent_default,
    selectedAttachProfile,
    for_bcid,
    order_form,
    selectedClients,
    lead_generation_form,
    lead_generation_external_link,
    account_creation,
    notification_scheduler,
    repeat_count,
    repeat_interval,
    initial_reminder_interval,
    supplier_default,
    required_business_type,
    business_type,
    ai_agent_creation,
    ai_agent_creation_external_link,
    captcha_enabled,
    is_sipnav,
  ) => {
    let form_accountno = this.props.props.match.params.id;
    let show_on_dashboard = showOnDashboard ? "1" : "0";
    let allowmultiple = allow_multiple ? "1" : "0";
    let isdefault = is_default ? "1" : "0";
    let agentdefault = agent_default ? "1" : "0";
    let supplierdefault = supplier_default ? "1" : "0";
    let aiAgentCreation = ai_agent_creation ? "1" : "0";
    let attachto = attach_to ? "1" : "0";
    let allowsubmit = allow_submit ? "1" : "0";
    let linkform = link_form ? "1" : "0";
    let forBcid = for_bcid ? "1" : "0";
    let orderform = order_form ? "1" : "0";
    let requiredBusinessType = required_business_type ? "1" : "0";
    let leadgeneration = lead_generation_form ? "1" : "0";
    let accountCreation = account_creation ? "1" : "0";
    let notificationScheduler = notification_scheduler ? "1" : "0";
    let requireCaptcha = captcha_enabled ? "1" : "0";
    let isSipnav = is_sipnav ? "1" : "0";
    const saveForm = await updateForm(
      auth.getAccount(),
      auth.getToken(),
      title,
      desc,
      content,
      form_accountno,
      form_sequence,
      btn_text,
      show_on_dashboard,
      allowmultiple,
      isdefault,
      groups_string,
      attachto,
      allowsubmit,
      linkform,
      external_link,
      agentdefault,
      selectedAttachProfile,
      forBcid,
      orderform,
      selectedClients,
      leadgeneration,
      lead_generation_external_link,
      accountCreation,
      notificationScheduler,
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      supplierdefault,
      requiredBusinessType,
      business_type,
      aiAgentCreation,
      ai_agent_creation_external_link,
      requireCaptcha,
      isSipnav,
    );
    // console.log("saveForm: ", saveForm.data);
    if (
      saveForm.data.status === 403 ||
      saveForm.data.errors === "authentication missing" ||
      saveForm.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveForm.data.status === 404 &&
      saveForm.data.message === "error"
    ) {
      this.setState({
        errorMessage: "There was some error while adding the form.",
      });
    } else if (
      saveForm.data.status === 200 &&
      saveForm.data.message === "success"
    ) {
      this.setState({
        successMessage:
          "Form updated successfully. The page will automatically refresh in a moment. Thank you for your patience.",
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      setTimeout(() => {
        window.location.replace("/forms");
      }, 4000);
    } else {
      this.setState({
        errorMessage: "There was some error while adding the form.",
      });
    }
  };

  handleOrderForm = (event) => {
    this.setState({
      order_form: event.target.checked,
      link_form: false,
      lead_generation_form: false,
      // Reset Submit-related state when switching to Order Form
      ...(event.target.checked && { allow_submit: true, btn_text: "" }),
    });
  };

  handleBusinessTypeForm = (event) => {
    this.setState({
      required_business_type: event.target.checked,
      link_form: false,
      lead_generation_form: false,
      // Reset Submit-related state when switching to Business Type Form
      ...(event.target.checked && { allow_submit: true, btn_text: "" }),
    });
  };

  handleInputFormatChange = (value) => {
    this.setState({ selectedAttachProfile: value }, () => {
      // console.log(
      //   "Updated selectedAttachProfile: ",
      //   this.state.selectedAttachProfile
      // );
    });
  };

  handleAgentDefaultChange = (event) => {
    this.setState({
      agent_default: event.target.checked,
    });
  };

  handleSupplierDefaultChange = (event) => {
    this.setState({
      supplier_default: event.target.checked,
    });
  };

  handleAIAgentCreationChange = (event) => {
    this.setState({
      ai_agent_creation: event.target.checked,
    });
  };

  handleAgentDefaultChange = (event) => {
    this.setState({
      agent_default: event.target.checked,
    });
  };

  handleOptionChange = (event) => {
    this.setState({
      showOnDashboard: event.target.checked,
    });
  };

  handleDefaultChange = (event) => {
    this.setState({
      is_default: event.target.checked,
    });
  };

  handleProfileChange = (event) => {
    this.setState({
      attach_to: event.target.checked,
    });
  };

  handleSubmitChange = (event) => {
    const isChecked = event.target.checked;
    
    // Prevent unchecking allow_submit when allow_multiple is enabled
    if (!isChecked && this.state.allow_multiple) {
      return;
    }
    
    this.setState({
      allow_submit: isChecked,
      // When Allow Submit is checked, uncheck Link Only (mutually exclusive)
      // When Allow Submit is unchecked, also uncheck Link Only
      link_form: false,
    });
  };

  handleCreationChange = (event) => {
    this.setState({
      account_creation: event.target.checked,
    });
  };

  handleMultipleChange = (event) => {
    const isChecked = event.target.checked;
    
    this.setState({
      allow_multiple: isChecked,
      // Auto-enable allow_submit when allow_multiple is enabled
      ...(isChecked && { allow_submit: true, link_form: false }),
      // When unchecking allow_multiple, also uncheck link_form
      ...(!isChecked && { link_form: false }),
    });
  };

  handleLinkChange = (event) => {
    const isChecked = event.target.checked;
    
    if (isChecked) {
      // When switching to Link Only mode, reset Submit-related states
      this.setState({
        link_form: true,
        allow_submit: false,
        btn_text: "",
        allow_multiple: false,
        // Prevent conflicting form types from being simultaneously enabled
        order_form: false,
        lead_generation_form: false,
      });
    } else {
      // When unchecking Link Only, also uncheck Allow Submit and Allow Multiple
      this.setState({
        link_form: false,
        allow_submit: false,
        allow_multiple: false,
      });
    }
  };

  handleLeadChange = (event) => {
    const isChecked = event.target.checked;
    
    if (isChecked) {
      // When switching to Lead Generation form, reset conflicting form types
      this.setState({
        lead_generation_form: true,
        link_form: false,
        order_form: false,
        allow_submit: true,
        btn_text: "",
      });
    } else {
      this.setState({
        lead_generation_form: false,
      });
    }
  };

  handleBcidChange = (event) => {
    this.setState({
      for_bcid: event.target.checked,
    });
  };

  handleSequenceChange = async (event) => {
    const { target } = event;
    let value = target.value;
    let parsedValue = parseInt(target.value);
    if (!parsedValue || parsedValue < 1 || parsedValue > 100) {
      this.setState({
        form_sequence_error: "The sequence can only be between 1-100",
        form_sequence: value,
      });
    } else {
      this.setState({
        form_sequence_error: "",
        form_sequence: value,
      });
    }
  };

  schedule_notification = () => {
    this.setState({
      notification_loader: false,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
    });
    window.$("#modalNotificationSchedule").modal("show");
  };

  handleNotificationSchedule = (event) => {
    // console.log("handleNotificationSchedule: ", event.target.checked);
    let schedule = event.target.checked;
    let schedule_div = false;
    if (schedule) {
      schedule_div = true;
    }
    this.setState({
      notification_scheduler: event.target.checked,
      schedule_div: schedule_div,
    });
  };

  handleChangeInitialReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ initial_reminder_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      this.setState({ initial_reminder_interval: numericValue });
    }
  };

  handleChangeRepeatReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 48) {
      this.setState({ repeat_interval: numericValue });
    }
  };

  handleChangeRepeatDays = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_count: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 12) {
      this.setState({ repeat_count: numericValue });
    }
  };

  submitNotifications = async () => {
    const {
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      notification_scheduler,
    } = this.state;

    this.setState({
      notification_loader: true,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
    });

    if (repeat_interval === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg: "Please enter the repeat reminder.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "" });
      }, 4000);
    } else if (repeat_count === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg:
          "Please enter the days for which this notification reminders will be sent.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "" });
      }, 4000);
    } else {
      this.setState({
        notificationErrorMsg: "",
        notificationSuccessMsg: "Notification settings added successfully.",
      });
      setTimeout(() => {
        this.setState({ notificationSuccessMsg: "" });
        window.$("#modalNotificationSchedule").modal("hide");
      }, 3000);
    }

    // console.log("notification_scheduler: ", notification_scheduler);
    // console.log("initial_reminder_interval: ", initial_reminder_interval);
    // console.log("repeat_interval: ", repeat_interval);
    // console.log("repeat_count: ", repeat_count);
  };

  getSuppliesBusinessTypes = async () => {
    try {
      const SuppliesBusinessTypes_res = await getSuppliesBusinessTypes(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("SuppliesBusinessTypes_res: ", SuppliesBusinessTypes_res.data);
      if (
        SuppliesBusinessTypes_res.data.status === 200 &&
        SuppliesBusinessTypes_res.data.data &&
        SuppliesBusinessTypes_res.data.data.length > 0
      ) {
        this.setState({
          supplier_business_types: SuppliesBusinessTypes_res.data.data,
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MODAL EDIT PROFILE START */}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/forms/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Forms
                  </Link>
                  <Typography color="textPrimary" className="">
                    Edit Form
                  </Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          {this.state.tableLoader === true ? (
            tableLoader()
          ) : (
            <>
              <div className="nk-block">
                {/* Table 5th Col Start */}
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="row g-4">
                            <div className="col-lg-6">
                              <h5 className="card-title">Edit Form</h5>
                            </div>
                            <div className="col-lg-6 text-right">
                              <a
                                onClick={() => this.schedule_notification()}
                                className={
                                  this.state.notification_scheduler === true
                                    ? "btn btn-success"
                                    : "btn btn-primary"
                                }
                                style={{ color: "white" }}
                              >
                                <em className="icon ni ni-calendar"></em>{" "}
                                <span>Notification Schedule</span>
                              </a>
                            </div>
                            <div className="col-lg-8">
                              <div className="form-group">
                                <MutextField
                                  required
                                  id="form_title"
                                  name="form_title"
                                  type="text"
                                  label="Form Title"
                                  value={this.state.form_title}
                                  onChange={this.handleChange}
                                  inputProps={{ maxLength: 100 }}
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="form_sequence"
                                    name="form_sequence"
                                    type="number"
                                    label="Sequence Number"
                                    value={this.state.form_sequence}
                                    inputProps={{ min: 1, max: 100 }}
                                    onChange={this.handleSequenceChange}
                                    variant="outlined"
                                    fullWidth
                                    style={{ height: "0.68em" }}
                                  autoComplete="new-password"
                                  />
                                  {this.state.form_sequence_error !== "" && (
                                    <p
                                      style={{
                                        color: "red",
                                        marginTop: "30px",
                                      }}
                                    >
                                      {this.state.form_sequence_error}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                {this.state.isEditorReady ? (
                                  <>
                                    <RichTextEditorComponent
                                      agreementContent={this.state.form_desc}
                                      onContentChange={this.handleEditorChange}
                                    />
                                  </>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <ul className="nk-kycfm-control-list g-3">
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="showOnDashboard"
                                      id="showOnDashboard"
                                      data-title="Show on dashboard"
                                      checked={this.state.showOnDashboard}
                                      onChange={this.handleOptionChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="showOnDashboard"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-dashboard"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Show on Dashboard
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="allow_multiple"
                                      id="allow_multiple"
                                      data-title="Allow Mutiple Submission"
                                      checked={this.state.allow_multiple}
                                      disabled={this.state.is_sipnav}
                                      onChange={this.handleMultipleChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="allow_multiple"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-repeat-v"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Allow Mutiple Submission
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="is_default"
                                      id="is_default"
                                      data-title="Default"
                                      checked={this.state.is_default}
                                      onChange={this.handleDefaultChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="is_default"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-flag"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Client Default
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox"
                                      name="agent_default"
                                      id="agent_default"
                                      data-title="Default"
                                      checked={this.state.agent_default}
                                      onChange={this.handleAgentDefaultChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="agent_default"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-flag"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        {
                                          localization.specificPortals
                                            .agentLabel
                                        }{" "}
                                        Default
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="attach_to"
                                      id="attach_to"
                                      data-title="Attach to Profile"
                                      checked={this.state.attach_to}
                                      onChange={this.handleProfileChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="attach_to"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-account-setting-fill"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Attach to Profile
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="allow_submit"
                                      id="allow_submit"
                                      data-title="Allow Submit"
                                      checked={this.state.allow_submit}
                                      onChange={this.handleSubmitChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="allow_submit"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-done"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Allow Submit
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="account_creation"
                                      id="account_creation"
                                      data-title="Enable for Client Creation"
                                      checked={this.state.account_creation}
                                      onChange={this.handleCreationChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="account_creation"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-user-add"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Enable for Client Creation
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox" // Use checkbox instead of radio for a toggle switch
                                      name="link_form"
                                      id="link_form"
                                      data-title="Link Only"
                                      checked={this.state.link_form}
                                      onChange={this.handleLinkChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="link_form"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-link-alt"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Link Only
                                      </span>
                                    </label>
                                  </li>
                                  {this.state.bcid_allowed === true &&
                                  this.state.api_status === true ? (
                                    <li className="nk-kycfm-control-item">
                                      <input
                                        className="nk-kycfm-control"
                                        type="checkbox" // Use checkbox instead of radio for a toggle switch
                                        name="for_bcid"
                                        id="for_bcid"
                                        data-title="For BCID"
                                        checked={this.state.for_bcid}
                                        onChange={this.handleBcidChange}
                                      autoComplete="new-password" />
                                      <label
                                        className="nk-kycfm-label"
                                        htmlFor="for_bcid"
                                      >
                                        <span className="nk-kycfm-label-icon">
                                          <div className="label-icon fs-22px">
                                            <em className="icon ni ni-exchange"></em>
                                          </div>
                                        </span>
                                        <span className="nk-kycfm-label-text">
                                          For BCID
                                        </span>
                                      </label>
                                    </li>
                                  ) : null}
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox"
                                      name="lead_generation_form"
                                      id="lead_generation_form"
                                      data-title="Lead Generation"
                                      checked={this.state.lead_generation_form}
                                      onChange={this.handleLeadChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="lead_generation_form"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-link-alt"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Lead Generation
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox"
                                      name="order_form"
                                      id="order_form"
                                      data-title="Attach to Profile"
                                      checked={this.state.order_form}
                                      onChange={this.handleOrderForm}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="order_form"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-account-setting-fill"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Order Form
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox"
                                      name="ai_agent_creation"
                                      id="ai_agent_creation"
                                      data-title="Conversational AI"
                                      checked={this.state.ai_agent_creation}
                                      onChange={
                                        this.handleAIAgentCreationChange
                                      }
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="ai_agent_creation"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-account-setting-fill"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Conversational AI
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      className="nk-kycfm-control"
                                      type="checkbox"
                                      name="captcha_enabled"
                                      id="captcha_enabled"
                                      data-title="Require CAPTCHA"
                                      checked={this.state.captcha_enabled}
                                      onChange={this.handleCaptchaEnabledChange}
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="captcha_enabled"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon fs-22px">
                                          <em className="icon ni ni-shield-check-fill"></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Require CAPTCHA Verification
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {this.state.showOnDashboard ? (
                              <>
                                <div className="col-lg-12">
                                  <h6>Show on Dashboard Settings</h6>
                                </div>
                                <div className="col-lg-6 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title={`How can the ${localization.specificPortals.agentText}/client access this form? e.g(Get Started)`}
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Button Text{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="btn_text"
                                        name="btn_text"
                                        type="text"
                                        label="Button Text"
                                        value={this.state.btn_text}
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 100 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {this.state.link_form ? (
                              <>
                                <div className="col-lg-12">
                                  <h6>Form Link Settings</h6>
                                </div>

                                <div className="col-lg-12 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Enter form link here"
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Link{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="external_link"
                                        name="external_link"
                                        type="text"
                                        label="Link"
                                        value={this.state.external_link}
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 255 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <table className="table table-striped">
                                      <tbody>
                                        <tr>
                                          <th scope="row">
                                            Dynamic Parameters
                                          </th>
                                          <td>
                                            <ul className="preview-list customStyle-badgeTransfrom">
                                              {this.state.va_intergation ===
                                              "Yes" ? (
                                                <>
                                                  <li className="preview-item">
                                                    <a
                                                      className="badge badge-outline-gray"
                                                      onClick={() =>
                                                        this.handleBadgeClick(
                                                          "{{va_parameters}}",
                                                        )
                                                      }
                                                    >
                                                      &#123;&#123;va_parameters&#125;&#125;
                                                    </a>
                                                    {this.state.showTooltip &&
                                                      this.state.copiedBadge ===
                                                        "{{va_parameters}}" && (
                                                        <div className="copyToClipboardTooltip active">
                                                          <span>
                                                            Copied to clipboard!
                                                          </span>
                                                        </div>
                                                      )}
                                                  </li>
                                                  <li className="preview-item">
                                                    <a
                                                      className="badge badge-outline-gray"
                                                      onClick={() =>
                                                        this.handleBadgeClick(
                                                          "{{va_parameters_brands}}",
                                                        )
                                                      }
                                                    >
                                                      &#123;&#123;va_parameters_brands&#125;&#125;
                                                    </a>
                                                    {this.state.showTooltip &&
                                                      this.state.copiedBadge ===
                                                        "{{va_parameters_brands}}" && (
                                                        <div className="copyToClipboardTooltip active">
                                                          <span>
                                                            Copied to clipboard!
                                                          </span>
                                                        </div>
                                                      )}
                                                  </li>
                                                </>
                                              ) : null}
                                            </ul>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {this.state.attach_to ? (
                              <>
                                <div className="col-lg-12">
                                  <h6>Attach to Profile</h6>
                                </div>
                                <div className="col-lg-3 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Select the profile to which this form will be attached"
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Profile Form Types{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-label-group">
                                      <MutextField
                                        id={`input-format`}
                                        name={`input-format`}
                                        select
                                        label="Input Format"
                                        value={this.state.selectedAttachProfile}
                                        onChange={(e) =>
                                          this.handleInputFormatChange(
                                            e.target.value,
                                          )
                                        }
                                        SelectProps={{
                                          native: true,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option
                                          key="kyc_profile"
                                          value="kyc_profile"
                                        >
                                          KYC
                                        </option>
                                        <option
                                          key="payment_detail_profile"
                                          value="payment_detail_profile"
                                        >
                                          Payment Details
                                        </option>
                                        <option
                                          key="billing_address_profile"
                                          value="billing_address_profile"
                                        >
                                          Billing Address
                                        </option>
                                        <option
                                          key="shipping_address_profile"
                                          value="shipping_address_profile"
                                        >
                                          Shipping Address
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {false && (
                              <>
                                <div className="col-lg-12">
                                  <h6>Order Form</h6>
                                </div>
                                <div className="col-lg-6 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="col-md-12">
                                      <div
                                        className="form-group"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={
                                                  this.state.selectAllClient
                                                }
                                                onChange={
                                                  this.handleSelectAllChange
                                                }
                                                name="selectAllClient"
                                              />
                                            }
                                            label="Select all Services"
                                            style={{
                                              width: "max-content",
                                              marginBottom: "10px",
                                              float: "right",
                                            }}
                                          />
                                          <Select
                                            id="selectedClients"
                                            value={this.state.selectedClients}
                                            isMulti
                                            name="clients"
                                            options={this.state.clientsList}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={this.handleSelectChange}
                                            styles={{
                                              control: (provided) => ({
                                                ...provided,
                                                minHeight: "56px",
                                              }),
                                              menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                            }}
                                          />
                                          <small>
                                            Select the services to which this
                                            form will be assigned. If a client
                                            fills out this form, an order with
                                            the assigned services will be
                                            created.
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {this.state.lead_generation_form ? (
                              <>
                                <div className="col-lg-12">
                                  <h6>Lead Generation Settings</h6>
                                </div>

                                <div className="col-lg-12 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Enter form link here"
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Api Url{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="lead_generation_external_link"
                                        name="lead_generation_external_link"
                                        type="text"
                                        label="Api Url"
                                        value={
                                          this.state
                                            .lead_generation_external_link
                                        }
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 255 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {this.state.ai_agent_creation && (
                              <>
                                <div className="col-lg-12">
                                  <h6>Conversational AI</h6>
                                </div>

                                <div className="col-lg-12 customStyle-sqnc-form">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Enter form link here"
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Api Url{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="ai_agent_creation_external_link"
                                        name="ai_agent_creation_external_link"
                                        type="text"
                                        label="Api Url"
                                        value={
                                          this.state
                                            .ai_agent_creation_external_link
                                        }
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 255 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-lg-12">
                              <div className="form-group">
                                <div className="supplier-settings">
                                  {/* Heading */}
                                  <h5 className="mb-3">Supplier Settings</h5>

                                  {/* Controls in one row */}
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: "20px" }}
                                  >
                                    {/* Supplier Default */}
                                    <div className="nk-kycfm-control-item flex-fill">
                                      <input
                                        className="nk-kycfm-control"
                                        type="checkbox"
                                        name="supplier_default"
                                        id="supplier_default"
                                        data-title="Default"
                                        checked={this.state.supplier_default}
                                        onChange={
                                          this.handleSupplierDefaultChange
                                        }
                                      autoComplete="new-password" />
                                      <label
                                        className="nk-kycfm-label"
                                        htmlFor="supplier_default"
                                      >
                                        <span className="nk-kycfm-label-icon">
                                          <div className="label-icon fs-22px">
                                            <em className="icon ni ni-flag"></em>
                                          </div>
                                        </span>
                                        <span className="nk-kycfm-label-text">
                                          Supplier Default
                                        </span>
                                      </label>
                                    </div>

                                    {/* Business Type */}
                                    <div className="nk-kycfm-control-item flex-fill">
                                      <MutextField
                                        id="business_type"
                                        name="business_type"
                                        select
                                        label={
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                          autoComplete="new-password"
                                          >
                                            <em
                                              className="icon ni ni-briefcase"
                                              style={{ fontSize: "1.4rem" }}
                                            ></em>
                                            Select Business Type{" "}
                                            {this.state.supplier_default ? (
                                              <span>*</span>
                                            ) : null}
                                          </span>
                                        }
                                        value={this.state.business_type}
                                        onChange={this.handleChange}
                                        SelectProps={{ native: true }}
                                        helperText=""
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        InputProps={{
                                          style: { height: "48px" },
                                        }}
                                        InputLabelProps={{
                                          shrink: true, // ✅ makes JSX label float like the second screenshot
                                        }}
                                        className="custom-business-type"
                                      >
                                        <option key="" value=""></option>
                                        {this.state.supplier_business_types.map(
                                          (type) => (
                                            <option
                                              key={type[0]}
                                              value={type[1]}
                                            >
                                              {type[1]}
                                            </option>
                                          ),
                                        )}
                                      </MutextField>
                                    </div>

                                    {/* Required Business Type */}
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox col-lg-3 flex-fill"
                                      style={{
                                        padding: 0,
                                        marginLeft: "3rem",
                                        height: "48px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="required_business_type"
                                        checked={
                                          this.state.required_business_type
                                        }
                                        onChange={this.handleBusinessTypeForm}
                                      autoComplete="new-password" />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="required_business_type"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          marginBottom: 0,
                                        }}
                                      >
                                        {/* <em className="icon ni ni-account-setting-fill"></em> */}
                                        Required
                                      </label>
                                    </div>
                                  </div>

                                  {/* Note */}
                                  <div
                                    className="mt-2 text-muted"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    Note: If <strong>Supplier Default</strong>{" "}
                                    is selected, then{" "}
                                    <strong>Business Type</strong> becomes
                                    mandatory.
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-lg-12">
                          <div className="form-group text-right">
                            <button
                              type="button"
                              onClick={() => this.formSave()}
                              className="btn btn-lg btn-primary"
                              disabled={this.state.disabled}
                            >
                              Save
                            </button>
                          </div>
                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          <div className="row g-4">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <FormBuilderClass
                                  from="addForm"
                                  form_title={this.state.form_title}
                                  form_desc={this.state.form_desc}
                                  form_content={this.state.form_content}
                                  groups={this.state.groups}
                                  onFormContentChange={
                                    this.handleFormContentChange
                                  }
                                  onGroupsChange={this.handleGroupsChange}
                                  onFormSubmit={this.handleFormSubmit}
                                  link_form={this.state.link_form}
                                  for_bcid={this.state.for_bcid}
                                  account_creation={this.state.account_creation}
                                  is_sipnav={this.state.is_sipnav}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Table 5th Col End */}
                {/* NOTIFICATION MODAL */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalNotificationSchedule"
                >
                  <div
                    className="modal-dialog modal-dialog-top modal-lg"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">Schedule Notifications</h5>
                      </div>
                      <div className="modal-body">
                        {this.state.notificationErrorMsg !== "" ? (
                          <div className="alert alert-pro alert-danger mb-3">
                            <div className="alert-text">
                              <h6>Missing Fields</h6>
                              <p>{this.state.notificationErrorMsg} </p>
                            </div>
                          </div>
                        ) : null}
                        {this.state.notificationSuccessMsg !== "" ? (
                          <div className="alert alert-pro alert-success mb-3">
                            <div className="alert-text">
                              <h6>Success</h6>
                              <p>{this.state.notificationSuccessMsg} </p>
                            </div>
                          </div>
                        ) : null}
                        <div className="col-md-12 mb-4">
                          <div className="custom-control custom-control-lg custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="notification_scheduler"
                              onChange={this.handleNotificationSchedule}
                              value={this.state.notification_scheduler}
                              checked={this.state.notification_scheduler}
                            autoComplete="new-password" />
                            <label
                              className="custom-control-label"
                              for="notification_scheduler"
                            >
                              Enable Notification Scheduler
                            </label>
                          </div>
                        </div>
                        {this.state.schedule_div === true ? (
                          <div className="col-md-12 mb-4">
                            <div className="form-group">
                              <label
                                className="form-label"
                                for="initial_reminder_interval"
                              >
                                Initial Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="initial_reminder_interval"
                                  name="initial_reminder_interval"
                                  placeholder="Allowed values between 1 to 24"
                                  onChange={this.handleChangeInitialReminder}
                                  value={this.state.initial_reminder_interval}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                              <div className="form-note"></div>
                            </div>
                            <div className="form-group">
                              <label className="form-label" for="repeat_interval">
                                Repeat Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_interval"
                                  name="repeat_interval"
                                  placeholder="Allowed values between 1 to 48"
                                  value={this.state.repeat_interval}
                                  onChange={this.handleChangeRepeatReminder}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                            <div className="form-group">
                              <label className="form-label" for="repeat_count">
                                Maximum Days
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_count"
                                  name="repeat_count"
                                  placeholder="Allowed values between 1 to 12 days"
                                  value={this.state.repeat_count}
                                  onChange={this.handleChangeRepeatDays}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                            <div className="form-group text-right">
                              {this.state.notification_loader === true ? (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span> Saving... </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.submitNotifications()}
                                  className="btn btn-primary"
                                >
                                  Submit
                                </button>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {/* NOTIFICATION MODAL */}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditForm);
